import {
  StyledAvatar,
  StyledAvatarName,
  StyledAvatarImage,
} from './Avatar.style';
import ProviderLogo from './ProviderLogo';

const Avatar = ({ imageUrl = null, username, onAvatarClick, provider }) => {
  const usernameAcronyms = username
    .split(' ')
    .slice(0, 2)
    .map(w => w[0])
    .join('')
    .toUpperCase();

  return (
    <StyledAvatar className='topbar-avatar' onClick={onAvatarClick}>
      {imageUrl ? (
        <StyledAvatarImage
          src={imageUrl}
          className='topbar-avatar-image'
        ></StyledAvatarImage>
      ) : (
        <StyledAvatarName className='topbar-avatar-name'>
          {usernameAcronyms}
        </StyledAvatarName>
      )}
      {provider && <ProviderLogo provider={provider}></ProviderLogo>}
    </StyledAvatar>
  );
};

export default Avatar;
